import PolylineExtended from "polyline-extended";
import React from "react";
import { useSelector } from "react-redux";
import { selector } from "../../store/reducers/currentRide";
import { locationSelector } from "../../store/reducers/location";
import GoogleMapBlock from "./GoogleMap";
import { useQuery } from "react-query";
import ClosestCarsService from "../../services/closestCars";
import { DefaultLocation } from '../../constants/location';

export default React.memo((props) => {
  const route = useSelector(state => selector(state)?.ride?.route);
  const location = useSelector(state => locationSelector(state));
  const puPoint = route?.routePoints?.[0];
  const doPoint = route?.routePoints?.[route?.routePoints?.length - 1];
  const overviewPolyline = route?.routePath?.overviewPolyline;
  const routePathPolyline = React.useMemo(() => {
    return overviewPolyline ? PolylineExtended.decode(overviewPolyline)
      .map(([ lat, lng ]) => ({
        lat,
        lng,
      })) : undefined;
  }, [ overviewPolyline ]);

  const mapCenter = React.useMemo(() => {
    return (location.lat && location.lng) ?
      location :
      DefaultLocation;
  }, [ location ]);

  const { data } = useQuery(["closestCars", (puPoint?.address?.location && !doPoint?.seqType) ? puPoint?.address?.location : undefined ], ClosestCarsService.getCars, {
    refetchInterval: 20 * 1000,
    refetchOnWindowFocus: true,
    queryFnParamsFilter: args => args.slice(1),
  });

  return (
    <GoogleMapBlock {...props}
                    puPoint={puPoint?.address?.location}
                    doPoint={doPoint?.address?.location}
                    routePathPolyline={routePathPolyline}
                    carsArray={data}
                    mapCenter={mapCenter}
                    searchingMode={false}
                    themeLightStyle={false}
    >

    </GoogleMapBlock>
  );
});

